import React from 'react'
import EducationDashboard from '../../../Components/Dashboard/Education'

export default function Education() {
    return (
        <div className='page-body'>
            <EducationDashboard />
        </div>
    )
}